<template>
  <div class="corePage">
    <div class="aBox1">
      <img
        class="ab1Img"
        src="http://cdn.xiyundata.com/crane_index/version3/v3plan01.png"
        alt=""
      />
      <img
        class="ab1Img2"
        src="http://cdn.xiyundata.com/crane_index/version3/v3plan02.png"
        alt=""
      />
    </div>
    <div class="aBox2">
      <div class="aBox2Content">
        <img class="ab2Img" src="http://cdn.xiyundata.com/crane_index/version3/v3plan03.png" alt="">
        <img class="ab2Img2" src="http://cdn.xiyundata.com/crane_index/version3/v3plan04.png" alt="">
      </div>
    </div>
    <div class="cBox6">
      <div class="cBox6Content">
        <div class="cb6Item" :class="activeIndex == 1 ? 'activeItem' : ''" @click="changeAct(1)">
          <div class="c6iTop">
            <img v-if="activeIndex != 1" class="c6iImg" src="http://cdn.xiyundata.com/crane_index/version3/icons/ship1.png" alt="">
            <img v-else class="c6iImg" src="http://cdn.xiyundata.com/crane_index/version3/icons/ship2.png" alt="">
          </div>
          <div class="c6iName">设备健康监测</div>
          <div class="c6iTxt">采用高精度传感器，能够准确测量设备的运行数据，确保数据的准确性和可靠性。</div>
        </div>
        <div class="cb6Item" :class="activeIndex == 2 ? 'activeItem' : ''" @click="changeAct(2)">
          <div class="c6iTop">
            <img v-if="activeIndex != 2" class="c6iImg" src="http://cdn.xiyundata.com/crane_index/version3/icons/net1.png" alt="">
            <img v-else class="c6iImg" src="http://cdn.xiyundata.com/crane_index/version3/icons/net2.png" alt="">
          </div>
          <div class="c6iName">数字孪生平台</div>
          <div class="c6iTxt">结合大数据分析和人工智能技术，对采集到的数据进行深度挖掘和分析。通过机器学习算法和统计模型，实现对设备健康状态的精准预测和评估。</div>
        </div>
        <div class="cb6Item" :class="activeIndex == 3 ? 'activeItem' : ''" @click="changeAct(3)">
          <div class="c6iTop">
            <img v-if="activeIndex != 3" class="c6iImg" src="http://cdn.xiyundata.com/crane_index/version3/icons/data1.png" alt="">
            <img v-else class="c6iImg" src="http://cdn.xiyundata.com/crane_index/version3/icons/data2.png" alt="">
          </div>
          <div class="c6iName">实时监测平台</div>
          <div class="c6iTxt">利用物联网技术，实现传感器与云端服务器之间的实时数据传输。即使在恶劣环境下，也能确保数据的实时性和完整性。</div>
        </div>
      </div>
    </div>
    <div class="cBox5">
      <div class="cBox5Content">
        <div class="c5Line1">物联港口</div>
        <div class="c5LineEng">PERFECT PRODUCT SYSTEM</div>
        <div class="c5Line2">
          如今，尽管我们无需亲自跨越国境，也能轻松购买到进口商品，这一便捷的购物体验背后，离不开口岸物流的高效运作。而口岸物流的高效，又得益于智能化的管理手段，它能够显著降低运营成本，从而提升进出口贸易的整体经济效益。作为专注于起重机应力监测的数港物联，我们同样在智慧口岸领域提供全面解决方案
        </div>
        <img class="cb5Img" src="http://cdn.xiyundata.com/crane_index/version3/v3plan05.png" alt="">
        <img class="cb5Img2" src="http://cdn.xiyundata.com/crane_index/version3/v3plan06.png" alt="">
      </div>
    </div>
    <div class="cBox7">
      <div class="cBox7Content">
        <div class="c7Line1">数字孪生</div>
        <div class="c7LineEng">PERFECT PRODUCT SYSTEM</div>
        <div class="c7Line2">
          数港物联数字孪生平台是一个集数据采集、模型构建、仿真分析、可视化展示于一体的综合性系统。它利用物联网、大数据、人工智能等先进技术，将物理世界中的实体或系统映射到虚拟的数字空间中，实现对物理世界的全面感知、精准模拟和智能决策。
        </div>
        <img class="cb7Img" src="http://cdn.xiyundata.com/crane_index/version3/v3plan05.png" alt="">
        <img class="cb7Img2" src="http://cdn.xiyundata.com/crane_index/version3/v3plan06.png" alt="">
      </div>
    </div>
    <div class="cBox8">
      <div class="cBox8Content">
        <div class="c8Line1">监测平台</div>
        <div class="c8LineEng">PERFECT PRODUCT SYSTEM</div>
        <div class="c8Line2">
          平台能够实时监测结构物的应力状态，包括应力大小、方向以及变化趋势等。 通过高精度的传感器和稳定的数据传输技术，确保数据的准确性和实时性。
        </div>
        <img class="cb8Img" src="http://cdn.xiyundata.com/crane_index/version3/v3plan07.png" alt="">
        <img class="cb8Img2" src="http://cdn.xiyundata.com/crane_index/version3/v3plan08.png" alt="">
      </div>
    </div>
  </div>
</template>

<script >
export default {
  data() {
    return {
      activeIndex: 1
    };
  },
  methods: {
    handleScroll() {
      // 淡入动画

      const windowHeight = window.innerHeight;
      const scrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;

      // const cBox4 = this.$el.querySelector(".cBox4");
      // const cBox4Top = cBox4.offsetTop;
      // if (
      //   scrollPosition + windowHeight > cBox4Top &&
      //   scrollPosition < cBox4Top + cBox4.offsetHeight
      // ) {
      //   cBox4.classList.add("fade-in-animation");
      // } else {
      //   cBox4.classList.remove("fade-in-animation");
      // }

      const cBox5 = this.$el.querySelector(".cBox5");
      const cBox5Top = cBox5.offsetTop;
      if (
        scrollPosition + windowHeight > cBox5Top &&
        scrollPosition < cBox5Top + cBox5.offsetHeight
      ) {
        cBox5.classList.add("fade-in-animation");
      } else {
        cBox5.classList.remove("fade-in-animation");
      }

      const cBox7 = this.$el.querySelector(".cBox7");
      const cBox7Top = cBox7.offsetTop;
      if (
        scrollPosition + windowHeight > cBox7Top &&
        scrollPosition < cBox7Top + cBox7.offsetHeight
      ) {
        cBox7.classList.add("fade-in-animation");
      } else {
        cBox7.classList.remove("fade-in-animation");
      }

      const cBox8 = this.$el.querySelector(".cBox8");
      const cBox8Top = cBox8.offsetTop;
      if (
        scrollPosition + windowHeight > cBox8Top &&
        scrollPosition < cBox8Top + cBox8.offsetHeight
      ) {
        cBox8.classList.add("fade-in-animation");
      } else {
        cBox8.classList.remove("fade-in-animation");
      }
    },
    changeAct(index) {
      this.activeIndex = index
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.corePage {
  /* padding-top: 70px; */
}
.aBox1 {
  width: 100vw;
}
.ab1Img {
  width: 100%;
}
.ab1Img2 {
  width: 100%;
}
.aBox2 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 550px;
  margin-bottom: 10px;
}
.aBox2Content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1200px;
  height: 100%;
  padding-top: 30px;
}
.ab2Img {
  width: 100%;
  height: auto;
}
.cBox6 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 340px;
  margin-bottom: 67px;
}
.cBox6Content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1200px;
  height: 100%;
}
.cb6Item {
  width: 33%;
  height: 100%;
  padding-top: 40px;
  background: #fdfdfe;
  cursor: pointer;
}
.c6iTop {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.c6iImg {
  width: 98px;
  height: 98px;
}
.c6iName {
  width: 100%;
  text-align: center;
  font-weight: 700;
  font-size: 26px;
  color: #999999;
  line-height: 38px;
  margin-bottom: 30px;
}
.c6iTxt {
  padding: 0 25px;
  font-weight: 400;
  font-size: 14px;
  color: #99999A;
  line-height: 21px;
}
.activeItem {
  background: #DA0010;
}
.activeItem .c6iName {
  color: #FFFFFF;
}
.activeItem .c6iTxt {
  color: #FFFFFF;
}
.cBox4 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 317px;
  margin-top: 20px;
}
.cBox4Content {
  width: 1200px;
  height: 100%;
}
.c4Line {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.c4TopImg {
  width: 275px;
  height: 140px;
  border: 1px solid #bcbcbc;
  border-radius: 6px;
  margin-bottom: 20px;
  overflow: hidden;
}
.c4TopPic {
  width: 275px;
  border-radius: 6px;
  vertical-align: middle;
}
.cBox5 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 766px;
  margin-bottom: 67px;
}
.cBox5Content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1200px;
  height: 100%;
}
.c5Line1 {
  font-weight: 700;
  font-size: 30px;
  color: #33333A;
  line-height: 1.4;
}
.c5LineEng {
  font-weight: 400;
  font-size: 14px;
  color: #99999A;
  line-height: 20px;
}
.c5Line2 {
  width: 891px;
  margin-top: 40px;
  font-weight: 400;
  font-size: 14px;
  color: #66666A;
  line-height: 24px;
  margin-bottom: 50px;
  text-align: center;
}

.cb5Img {
  width: 100%;
}

.cBox7 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 900px;
  margin-bottom: 67px;
  background: #030814;
  padding-top: 68px;
}
.cBox7Content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1200px;
  height: 100%;
}
.c7Line1 {
  font-weight: 700;
  font-size: 30px;
  color: #FFFFFF;
  line-height: 1.4;
}
.c7LineEng {
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 20px;
}
.c7Line2 {
  width: 891px;
  margin-top: 40px;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 24px;
  margin-bottom: 50px;
  text-align: center;
}

.cb7Img {
  width: 100%;
}

.cBox8 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 766px;
  margin-bottom: 67px;
}
.cBox8Content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1200px;
  height: 100%;
}
.c8Line1 {
  font-weight: 700;
  font-size: 30px;
  color: #33333A;
  line-height: 1.4;
}
.c8LineEng {
  font-weight: 400;
  font-size: 14px;
  color: #99999A;
  line-height: 20px;
}
.c8Line2 {
  width: 476px;
  margin-top: 40px;
  font-weight: 400;
  font-size: 14px;
  color: #66666A;
  line-height: 24px;
  margin-bottom: 50px;
  text-align: center;
}

.cb8Img {
  width: 100%;
}

.fade-in-animation {
  animation: fade-in 1.1s ease-in-out forwards;
}

/* 淡入动画 */
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* 媒体查询，屏幕宽度小于830px */
@media (max-width: 830px) {
  .ab1Img {
    display: none;
  }
  .ab1Img2 {
    display: block;
  }
  .aBox2 {
    height: auto;
    margin-bottom: 0px;
  }
  .aBox2Content {
    padding: 0;
  }
  .cBox3Content {
    width: 100%;
    padding-left: 40px;
    padding-right: 40px;
  }
  .c3iPic {
    width: 35px;
    height: 35px;
  }
  .c3iTxt {
    font-size: 11px;
  }
  .c3Bottom {
    font-size: 12px;
  }
  .cBox4Content {
    width: 67%;
  }
  .cBox4 {
    height: auto;
  }
  .c4TopImg {
    height: 100%;
    flex: 1 1 46%; /* 两个项目，每个项目占据48%宽度 */
    margin-right: 2%; /* 右边距 */
    margin-bottom: 4%; /* 下边距 */
    max-width: 46%; /* 最大宽度限制 */
  }
  .c4TopPic {
    width: 100%;
  }
  .cBox5 {
    height: auto;
    margin-bottom: 0px;
  }
  .cBox5Content {
    width: 100%;
  }
  .c5Line1 {
    font-size: 23px;
  }
  .c5Line2 {
    width: 96%;
    font-size: 12px;
    margin-top: 30px;
    padding-left: 30px;
    padding-right: 30px;
  }
  .cb5Img {
    display: none;
  }
  .cb5Img2 {
    display: block;
    width: 100%;
  }
  
  .cBox7 {
    height: auto;
    margin-bottom: 0px;
  }
  .cBox7Content {
    width: 100%;
  }
  .c7Line1 {
    font-size: 23px;
  }
  .c7Line2 {
    width: 96%;
    font-size: 12px;
    margin-top: 30px;
    padding-left: 30px;
    padding-right: 30px;
  }
  .cb7Img {
    display: none;
  }
  .cb7Img2 {
    display: block;
    width: 100%;
  }
  
  .cBox8 {
    height: auto;
    margin-bottom: 0px;
    margin-top: 55px;
  }
  .cBox8Content {
    width: 100%;
  }
  .c8Line1 {
    font-size: 23px;
  }
  .c8Line2 {
    width: 96%;
    font-size: 12px;
    margin-top: 30px;
    padding-left: 30px;
    padding-right: 30px;
  }
  .cb8Img {
    display: none;
  }
  .cb8Img2 {
    display: block;
    width: 100%;
  }
  .ab2Img {
    display: none;
  }
  .ab2Img2 {
    display: block;
    width: 100%;
    height: auto;
  }
  .cBox6 {
    margin-bottom: 55px;
  }
  .c6iImg {
    width: 70px;
    height: 70px;
  }
  .c6iTop {
    margin-bottom: 10px;
  }
  .c6iName {
    font-size: 16px;
    margin-bottom: 5px;
  }
  .c6iTxt {
    font-size: 14px;
    padding: 0 12px;
  }
}

@media (min-width: 830px) {
  .ab1Img {
    display: block;
  }
  .ab1Img2 {
    display: none;
  }
  .c4TopImg {
    flex: 1 1 22%; /* 四个项目，每个项目占据22%宽度 */
    margin-right: 2%; /* 右边距 */
    margin-bottom: 2%; /* 下边距 */
    max-width: 22%; /* 最大宽度限制 */
  }
  .ab2Img {
    display: block;
  }
  .ab2Img2 {
    display: none;
  }
  .cb5Img {
    display: block;
  }
  .cb5Img2 {
    display: none;
  }
  .cb7Img {
    display: block;
  }
  .cb7Img2 {
    display: none;
  }
  .cb8Img {
    display: block;
  }
  .cb8Img2 {
    display: none;
  }
}
</style>
